import ProfileIcon from "../icons/ProfileIcon"

export default {
    icon: ProfileIcon,
    layout: "editor",
    url: "/profile",
    title: "Profil"
}